<template>
  <div class="progress-slider-wrap">
    <div class="progress-viewport" ref="viewport">
      <div class="progress-pages" :style="pagesStyle">
        <div
          class="progress-page"
          v-for="(page, pageIndex) in pages"
          :key="pageIndex"
        >
          <div class="year-column" v-for="item in page" :key="item.year">
            <div class="year-title">{{ item.year }}年</div>
            <div class="year-line"></div>
            <div class="year-desc">
              <div
                class="desc-item"
                v-for="(text, index) in item.items"
                :key="index"
              >
                {{ text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="totalPages > 1"
      class="slider-track"
      ref="track"
      @mousedown="onTrackMouseDown"
      @touchstart.prevent="onTrackTouchStart"
    >
      <div class="slider-track-active" :style="activeTrackStyle"></div>
      <div
        class="slider-thumb"
        :style="thumbStyle"
        @mousedown.stop="onThumbMouseDown"
        @touchstart.stop.prevent="onThumbTouchStart"
      >
        <i class="el-icon-arrow-right" style="color: #fff"></i>
      </div>
    </div>
  </div>
</template>

<script>
const HISTORY_DATA = [
  {
    year: 2025,
    items: [
      "焱图清洗无人机荣获AIPV 2024年智能光伏示范产品",
      "焱图智能机器人（盐城）有限公司成立",
      "清洗机器人第三代开始量产",
    ],
  },
  {
    year: 2024,
    items: [
      "推出光伏行业首个人工智能大模型——“绿能百科”",
      "荣获“2023年光伏系统集成智能示范企业”",
      "光伏一点通荣获“2023年分布式光伏智能示范产品”",
      "推出光伏清洗机器人和无人机",
    ],
  },
  {
    year: 2023,
    items: ["成为大疆生态合作伙伴", "荣获2023好光伏“年度新锐企业”奖"],
  },
  {
    year: 2022,
    items: [
      "8月，喜获苏州市姑苏创新创业领军人才",
      "12月，获得高新技术企业认定",
    ],
  },
  {
    year: 2021,
    items: [
      "4月，推出无人机智能飞行控制APP产品及在线实景建模云平台",
      "7月，推出智能光伏运维巡检产品",
      "10月，喜获“智汇苏高新”创新创业大赛第一名",
      "推出“光伏一点通”产品",
      "11月，喜获苏州市高新区科技创新创业领军人才",
    ],
  },
  {
    year: 2020,
    items: ["公司成立", "11月，推出AI图像分析平台"],
  },
];

const PAGE_SIZE = 3;
const THUMB_WIDTH = 20;

export default {
  data() {
    return {
      historyData: HISTORY_DATA,
      scrollRatio: 0,
      dragLeft: 0,
      isDragging: false,
      viewportWidth: 0,
      trackWidth: 280,
    };
  },
  computed: {
    pages() {
      const pages = [];
      for (let i = 0; i < this.historyData.length; i += PAGE_SIZE) {
        pages.push(this.historyData.slice(i, i + PAGE_SIZE));
      }
      return pages;
    },
    totalPages() {
      return this.pages.length;
    },
    maxThumbLeft() {
      return Math.max(this.trackWidth - THUMB_WIDTH, 0);
    },
    maxScrollOffset() {
      return Math.max((this.totalPages - 1) * this.viewportWidth, 0);
    },
    pagesStyle() {
      return {
        transform: `translateX(-${this.scrollRatio * this.maxScrollOffset}px)`,
        transition: this.isDragging ? "none" : "none",
      };
    },
    thumbStyle() {
      return {
        left: `${this.dragLeft}px`,
      };
    },
    activeTrackStyle() {
      return {
        width: `${this.dragLeft + THUMB_WIDTH / 2}px`,
      };
    },
  },
  mounted() {
    this.updateSizes();
    window.addEventListener("resize", this.updateSizes);
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
    document.addEventListener("touchmove", this.onTouchMove, {
      passive: false,
    });
    document.addEventListener("touchend", this.onTouchEnd);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateSizes);
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
    document.removeEventListener("touchmove", this.onTouchMove);
    document.removeEventListener("touchend", this.onTouchEnd);
  },
  methods: {
    updateSizes() {
      this.$nextTick(() => {
        if (this.$refs.viewport) {
          this.viewportWidth = this.$refs.viewport.offsetWidth;
        }
        if (this.$refs.track) {
          this.trackWidth = this.$refs.track.offsetWidth;
        }
        this.syncThumbFromRatio();
      });
    },
    syncThumbFromRatio() {
      this.dragLeft = this.scrollRatio * this.maxThumbLeft;
    },
    syncRatioFromThumb(left) {
      const clampedLeft = Math.max(0, Math.min(left, this.maxThumbLeft));
      this.dragLeft = clampedLeft;
      if (this.maxThumbLeft > 0) {
        this.scrollRatio = clampedLeft / this.maxThumbLeft;
      } else {
        this.scrollRatio = 0;
      }
    },
    getPointerLeft(clientX) {
      const track = this.$refs.track;
      if (!track) {
        return 0;
      }
      const rect = track.getBoundingClientRect();
      return clientX - rect.left - THUMB_WIDTH / 2;
    },
    onThumbMouseDown() {
      this.isDragging = true;
    },
    onThumbTouchStart() {
      this.isDragging = true;
    },
    onTrackMouseDown(event) {
      if (event.target.closest(".slider-thumb")) {
        return;
      }
      this.syncRatioFromThumb(this.getPointerLeft(event.clientX));
    },
    onTrackTouchStart(event) {
      const touch = event.touches[0];
      this.syncRatioFromThumb(this.getPointerLeft(touch.clientX));
    },
    onMouseMove(event) {
      if (!this.isDragging) {
        return;
      }
      this.syncRatioFromThumb(this.getPointerLeft(event.clientX));
    },
    onTouchMove(event) {
      if (!this.isDragging) {
        return;
      }
      event.preventDefault();
      const touch = event.touches[0];
      this.syncRatioFromThumb(this.getPointerLeft(touch.clientX));
    },
    onMouseUp() {
      this.isDragging = false;
    },
    onTouchEnd() {
      this.isDragging = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.progress-slider-wrap {
  width: 84%;
  max-width: var(--main-width);
  margin-top: 4.93rem;

  .progress-viewport {
    overflow: hidden;
    width: 100%;
  }

  .progress-pages {
    display: flex;
    will-change: transform;
  }

  .progress-page {
    flex: 0 0 100%;
    display: flex;
    justify-content: space-between;
    gap: 2.5rem;
    box-sizing: border-box;
    padding: 0 0.5rem;
  }

  .year-column {
    flex: 1;
    min-width: 0;
  }

  .year-title {
    font-size: 2.25rem;
    color: #2372E9;
    font-weight: bold;
    margin-bottom: 0.75rem;
  }

  .year-line {
    width: 100%;
    height: 1px;
    background: #E6E5E5;
    margin-bottom: 1.25rem;
  }

  .desc-item {
    position: relative;
    padding-left: 1rem;
    line-height: 1.625rem;
    color: #333;
    font-size: 0.875rem;

    &:not(:last-child) {
      margin-bottom: 0.625rem;
    }

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0.5rem;
      width: 6px;
      height: 6px;
      background: #666666;
      border-radius: 50%;
    }
  }

  .slider-track {
    width: 17.5rem;
    height: 6px;
    background: #E6E5E5;
    border-radius: 3px;
    margin: 5.5rem auto 0;
    position: relative;
    cursor: pointer;
  }

  .slider-track-active {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: #2372E9;
    border-radius: 3px;
    pointer-events: none;
    z-index: 1;
  }

  .slider-thumb {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 28px;
    background: #2372E9;
    border-radius: 3px;
    border: 1px solid #FFFFFF;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    box-shadow: 0 2px 6px rgba(35, 114, 233, 0.35);
    z-index: 2;

    &::before {
      content: "";
      position: absolute;
      left: -6px;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      border-radius: 3px 0 0 3px;
      background: #2372E9;
    }

    &:active {
      cursor: grabbing;
    }
  }

  .arrow-icon {
    color: #fff;
    font-size: 0.875rem;
    line-height: 1;
    font-weight: bold;
    transform: scaleY(1.2);
  }
}
</style>
